<section class="users-page">
  <header class="page-header">
    <div>
      <h1>Utilisateurs</h1>
      <p>Gestion des comptes (création, modification, suppression) et accès au détail.</p>
    </div>
    <div class="header-actions">
      <button type="button" class="ghost" (click)="loadUsers()" [disabled]="loading">Rafraîchir</button>
      <button type="button" class="primary" (click)="startCreate()" [disabled]="saving">Nouvel utilisateur</button>
    </div>
  </header>

  <p class="message error" *ngIf="errorMessage">{{ errorMessage }}</p>
  <p class="message success" *ngIf="successMessage">{{ successMessage }}</p>

  <div class="layout">
    <section class="panel list">
      <div class="list-header">
        <h2>Liste</h2>
        <input
          type="search"
          [value]="searchQuery"
          (input)="applySearch(($any($event.target).value || '').toString())"
          placeholder="Rechercher par nom ou email..."
        />
      </div>

      <div class="state loading-state" *ngIf="loading">
        <span class="spinner" aria-hidden="true"></span>
        <span>Chargement…</span>
      </div>
      <div class="state" *ngIf="!loading && users.length === 0">Aucun utilisateur non anonyme sur cette page.</div>

      <ul *ngIf="!loading && users.length > 0">
        <li *ngFor="let user of users">
          <div class="main">
            <strong>{{ user.member?.displayName || ((user.member?.firstname || '') + ' ' + (user.member?.lastname || '')).trim() || user.email }}</strong>
            <span>{{ user.email }}</span>
            <div class="meta">
              <span>{{ roleLabel(user) }}</span>
              <span [class.disabled]="user.enabled === false">{{ user.enabled === false ? 'Désactivé' : 'Actif' }}</span>
            </div>
          </div>
          <div class="actions">
            <a [routerLink]="['/dashboard/users', user.id]" class="ghost link" *ngIf="user.id">Voir</a>
            <button type="button" class="ghost" (click)="startEdit(user)" [disabled]="saving">Modifier</button>
            <button type="button" class="danger" (click)="delete(user)" [disabled]="isDeleting(user.id)">
              {{ isDeleting(user.id) ? 'Suppression…' : 'Supprimer' }}
            </button>
          </div>
        </li>
      </ul>

      <footer class="pagination">
        <span>{{ totalItems }} résultat(s) affiché(s)</span>
        <div>
          <button type="button" class="ghost" (click)="previousPage()" [disabled]="currentPage === 0">Préc.</button>
          <span>Page {{ currentPage + 1 }} / {{ totalPages }}</span>
          <button type="button" class="ghost" (click)="nextPage()" [disabled]="currentPage + 1 >= totalPages">Suiv.</button>
        </div>
      </footer>
    </section>

    <section class="panel editor">
      <h2>{{ editingUserId == null ? 'Ajouter un utilisateur' : 'Modifier l’utilisateur #' + editingUserId }}</h2>

      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="grid two">
          <label>
            <span>Prénom</span>
            <input type="text" formControlName="firstname" />
          </label>
          <label>
            <span>Nom</span>
            <input type="text" formControlName="lastname" />
          </label>
        </div>

        <label>
          <span>Email</span>
          <input type="email" formControlName="email" />
        </label>

        <label *ngIf="editingUserId == null">
          <span>Mot de passe</span>
          <input type="password" formControlName="password" placeholder="minimum 6 caractères" />
        </label>

        <div class="grid two">
          <label>
            <span>Rôle</span>
            <select formControlName="role">
              <option *ngFor="let role of roles" [value]="role">{{ role }}</option>
            </select>
          </label>

          <label class="checkbox">
            <span>Statut</span>
            <label class="toggle">
              <input type="checkbox" formControlName="enabled" />
              <span>Compte actif</span>
            </label>
          </label>
        </div>

        <label>
          <span>Nom affiché (optionnel)</span>
          <input type="text" formControlName="displayName" />
        </label>

        <label>
          <span>Biographie (optionnel)</span>
          <textarea rows="3" formControlName="biography"></textarea>
        </label>

        <label>
          <span>Avatar URL (optionnel)</span>
          <input type="text" formControlName="avatarUrl" />
        </label>

        <div class="form-actions">
          <button type="submit" class="primary" [disabled]="saving">
            {{ saving ? 'Enregistrement…' : editingUserId == null ? 'Créer' : 'Mettre à jour' }}
          </button>
          <button type="button" class="ghost" (click)="startCreate()" [disabled]="saving">Réinitialiser</button>
        </div>
      </form>
    </section>
  </div>
</section>
